<app-dialog [title]="data.title" [actions]="[
    { text: 'Cancel', buttonStyle: 'underline' },
    {
      text: 'Create',
      isDisabled: !publishForm.valid,
      spin: spin
    }
  ]" (action)="dialogAction($event)" (close)="dialogRef.close()">
    <div class="input-container my-4">
        <label class="input-container_label">Enter your GTIN</label>
        <div class="input-container_wrapper">
            <input type="text" class="input-container_input" (input)="search($event)" />
            <app-button [isDisabled]="!gtin" [spin]="loader" (click)="submit()">
                Search</app-button>
        </div>
    </div>
    <div class="sku_detail" *ngIf="publisListing">
        <div class="sku_image">
            <img [src]="publisListing?.images[0]?.url" />
        </div>
        <div class="w-100">
            <div class="sku">
                <div class="sku_title">{{ publisListing?.title }}</div>
                <div class="sku_chips">
                    <app-sku-chip *ngIf="publisListing?.description" [name]="'title'" [value]="publisListing?.description"></app-sku-chip>
                </div>
            </div>
            <div class="panel-detail" *ngIf="publisListing">
                <div>
                    <span class="label">GTIN</span>
                    <p>{{ gtin }}</p>
                </div>

                <div>
                    <span class="label">Product Type</span>
                    <p>{{ publisListing?.productType }}</p>
                </div>

                <div>
                    <span class="label">Brand</span>
                    <p>{{ publisListing?.brand }}</p>
                </div>

                <div>
                    <span class="label">Price</span>
                    <p>{{ publisListing?.price?.amount | currency}}</p>
                </div>
            </div>
        </div>
    </div>
    <div class="container publishForm">
        <div class="row justify-content-center">
            <div [formGroup]="publishForm" class="col-md-10">
                <div class="input-container">
                    <label class="input-container_label">Seller SKU</label>
                    <div class="input-container_wrapper w-100">
                        <input class="input-container_input" type="text" formControlName="sku" />
                        <app-button (click)="openDialog()">generate</app-button>
                    </div>
                </div>
                <div class="input-container">
                    <label class="input-container_label">Your Price</label>
                    <div class="input-container_wrapper w-100">
                        <input type="number"
                            class="input-container_input input-container_input--number input-container_price" min="0"
                            formControlName="price" />
                        <span class="input-container_icon">
                            <i class="fa fa-dollar-sign"></i>
                        </span>
                    </div>
                </div>
                <div class="input-container">
                    <label class="input-container_label">Item Condition</label>
                    <mat-select class="input-container_input input-container_input--select"
                        formControlName="condition">
                        <mat-option *ngFor="let item of itemConditionWalmartArray" [value]="item">
                            {{ item }}
                        </mat-option>
                    </mat-select>
                </div>
                <div class="input-container">
                    <label class="input-container_label">Quantity</label>
                    <input type="number" min="0" class="input-container_input" formControlName="qty" />
                </div>

                <div class="input-container">
                    <label class="input-container_label">Visible</label>
                    <mat-select class="input-container_input input-container_input--select" formControlName="visible">
                        <mat-option *ngFor="let item of visibleArray" [value]="item">
                            {{ item }}
                        </mat-option>
                    </mat-select>
                </div>

                <div class="input-container">
                    <label class="input-container_label">Shipping Weight</label>
                    <input type="number" min="0" class="input-container_input" formControlName="shippingWeight" />
                </div>
            </div>
        </div>
    </div>
</app-dialog>